enum DataTableActionEnum {
  SET_FILTER = 'SET_FILTER',
  CLEAR_FILTER = 'CLEAR_FILTER',
  SET_SORT_OPTIONS_ORDER = 'SET_SORT_OPTIONS_ORDER',
  CLEAR_SORT_OPTIONS_ORDER = 'CLEAR_SORT_OPTIONS_ORDER',
}

export default DataTableActionEnum;
